import { render, staticRenderFns } from "./SubscriptionDelete.vue?vue&type=template&id=5c72c104&scoped=true"
import script from "./SubscriptionDelete.vue?vue&type=script&lang=js"
export * from "./SubscriptionDelete.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionDelete.vue?vue&type=style&index=0&id=5c72c104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c72c104",
  null
  
)

export default component.exports